export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'T-CECC-01',
        data: [
            {
                cross_section: '4420',
                base_exp: '0.3',
                base_cntr: '0.5',
                cmp_exp: '0.6',
                cmp_cntr:'0.7'
            },
            {
                cross_section: '5505',
                base_exp: '0.3',
                base_cntr: '0.5',
                cmp_exp: '0.6',
                cmp_cntr:'0.7'
            },
        ]
    }
]